
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React, { useEffect,  useRef } from 'react';
import { lerp } from '../Utils'

export default function Content0(props) {

    const mobile = useMediaQuery('(max-width:960px)');

    var div = useRef();
    var secondAnim = useRef();

    useEffect(() => {
        window.onscroll = () => {

   

            const offset = (window.innerHeight * 5.33)

            var time = ( (window.scrollY - offset) / window.innerHeight) / 1;
            var time1 = ( (window.scrollY - secondAnim.current) / window.innerHeight) / 1;

            if(time < 0.98)
            {
                if( window.scrollY > offset)
                {
                    secondAnim.current = window.scrollY;
                    div.current.style.opacity = lerp(0, 1,time )
                }
                else
                {
                    div.current.style.opacity = 0
                }
            }
            else
            {
                if(time1 < 0.98)
                {
                    div.current.style.opacity = lerp(1, 0, time1 )
                }
                else
                {
                    div.current.style.opacity = 0
                }
            }

        }
    }, []);

    

    return (
        <div 
            ref={div}
            style={{
                textAlign: `center`,
                fontSize: mobile ? `36px` : `63px`,
                color: `whitesmoke`,
                marginBottom: mobile ? '300px' : '450px',
                fontFamily:'sofia-pro',
                display: 'block',
                position:'fixed',
                opacity:0
                  
            }}
            >
                Från ide till  <br />
                verklighet 
        </div>
    );
}